import React from 'react';
// import PropTypes from 'prop-types';
// import styles from './myAccount.scss';

const myAccount = props => (
	<div>This is a component called myAccount.</div>
);

// todo: Unless you need to use lifecycle methods or local state,
// write your component in functional form as above and delete
// this section. 
// class myAccount extends React.Component {
//   render() {
//     return <div>This is a component called myAccount.</div>;
//   }
// }

const myAccountPropTypes = {
	// always use prop types!
};

myAccount.propTypes = myAccountPropTypes;

export default myAccount;
